var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.contract.supplementary_agreements &&
      ((_vm.purchase.contract.supplementary_agreements.length === 0 &&
        _vm.$store.getters.isLoggedIn &&
        _vm.purchase.is_customer &&
        _vm.purchase.actions.customer.supplementary_agreement !== "disallow") ||
        _vm.purchase.contract.supplementary_agreements.length > 0)
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "text-header",
                    {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-contract-annexes" },
                    },
                    [_vm._v("Дополнительные соглашения")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.purchase.contract.supplementary_agreements.length > 0
        ? _c(
            "div",
            { staticClass: "accordion", attrs: { role: "tablist" } },
            _vm._l(
              _vm.purchase.contract.supplementary_agreements,
              function (supplementaryAgreement, key) {
                return _c(
                  _vm.supplementaryAgreementComponent(supplementaryAgreement),
                  {
                    key: `supplementary-agreement-${key}`,
                    tag: "component",
                    attrs: {
                      title: `${supplementaryAgreement.type.title} №${supplementaryAgreement.number}`,
                      purchase: _vm.purchase,
                      "supplementary-agreement": supplementaryAgreement,
                      visible:
                        _vm.purchase.contract
                          .latest_supplementary_agreement_id ===
                        supplementaryAgreement.id,
                    },
                    on: {
                      refresh: function ($event) {
                        return _vm.refresh($event)
                      },
                    },
                  }
                )
              }
            ),
            1
          )
        : _vm._e(),
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.is_customer &&
      _vm.purchase.actions.customer.supplementary_agreement === "create"
        ? _c(
            "private-fl44-unknown-volume-send-supplementary-agreement-customer-block",
            {
              attrs: { purchase: _vm.purchase },
              on: {
                refresh: function ($event) {
                  return _vm.refresh($event)
                },
              },
            }
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }